const pageToNumber = (page, questionnaire) => {
  const checkPage = ({ path }) => path === page;
  return questionnaire.findIndex(checkPage);
};

export default pageToNumber;
